import {Button, useNotify} from "react-admin";
import DescriptionIcon from "@material-ui/icons/Description";
import {clientNoJson} from "../../dataProvider";
import {useState} from "react";
import {url as URL} from "../../constants";
import {CircularProgress} from "@material-ui/core";
import {getFileNameFromContentDisposition} from "../../shared/utils";

export const DriverSummaryPdfButton = (props: any) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const record = { ...props.props }

  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    let res = null;
    try {
      res = await clientNoJson(`${URL}/routes/driver_summary/`, {
        method: "POST",
        data: { ids: [record.id] },
        responseType: "arraybuffer",
      });
    } catch (err) {
      notify("ra.message.error", "error");
      setLoading(false);
      return;
    }
    setLoading(false);
    const data = res.data; // or res.blob() if using blob responses

    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: res.headers["content-type"],
      })
    );
    const actualFileName = getFileNameFromContentDisposition(
      res.headers["content-disposition"]
    );

    // uses the download attribute on a temporary anchor to trigger the browser
    // download behavior. if you need wider compatibility, you can replace this
    // part with a library such as filesaver.js
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", actualFileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) link.parentNode.removeChild(link);

  };

  return (
    props &&
    <Button
      label="Attiv."
      title="Attività autista"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <DescriptionIcon />}
    </Button>
  );
};
